import { FC } from 'react'

import DialogWindow from '@/components/DialogWindow'
import { Typography } from '@/components/ui'
import ButtonLink from '@/components/ui/button_link/ButtonLink'

import { IGeneratedHighlightResult } from '@/types/highlight.interface'

import FolderColorBalls from './FolderColorBalls'

interface ILinksDialogProps {
	open: boolean
	onClose: () => void
	results: IGeneratedHighlightResult[]
}

const LinksDialog: FC<ILinksDialogProps> = ({ open, onClose, results }) => {
	return (
		<DialogWindow
			open={open}
			onClose={onClose}
			titleText='Select options'
			hideButtons={true}
			handleClick={() => {}}
			bodyClassname='flex flex-col gap-4'
			body={
				<div className='flex flex-col gap-4'>
					{results.map(result => (
						<div
							key={result.id}
							className='grid grid-cols-[1fr_auto] items-center gap-4'
						>
							<div className='flex items-center gap-3 min-w-0'>
								<div className='flex flex-col gap-[2px] shrink-0'>
									<FolderColorBalls colorCode={result.colorCode} />
								</div>

								<div className='min-w-0'>
									<Typography
										variant='text'
										className='truncate text-neutral-900'
									>
										{result.name}
									</Typography>
									<Typography variant='text' className='text-neutral-700'>
										{result.segmentsCount} highlights, {result.totalTime}
									</Typography>
								</div>
							</div>

							<div className='flex items-center gap-3'>
								<ButtonLink
									type='MP4'
									label='MP4'
									files={result.files}
									linkClassName='bg-neutral-200 hover:bg-neutral-300 rounded-[8px] px-6 py-3'
									textClassName='!text-neutral-900 !font-medium'
								/>
								<ButtonLink
									type='SRT'
									label='SRT'
									files={result.files}
									linkClassName='bg-neutral-200 hover:bg-neutral-300 rounded-[8px] px-6 py-3'
									textClassName='!text-neutral-900 !font-medium'
								/>
								<ButtonLink
									type='SRT en'
									label='SRT EN'
									files={result.files}
									linkClassName='bg-neutral-200 hover:bg-neutral-300 rounded-[8px] px-6 py-3'
									textClassName='!text-neutral-900 !font-medium'
								/>
							</div>
						</div>
					))}
				</div>
			}
		/>
	)
}

export default LinksDialog
